import { PlaneView } from '../../../../view/views/PlaneView';
import { SvgCursor } from './SvgCursor';

export enum TranslationCursorMode {
    DEFAULT = 'default',
    GRAB = 'grab',
}

export class TranslationCursor extends SvgCursor {
    protected _mode: TranslationCursorMode;

    constructor(views: PlaneView[] | null) {
        super(views);
        this._mode = TranslationCursorMode.DEFAULT;
        this.setCustomCursor();
    }

    public setMode(mode: TranslationCursorMode) {
        this._mode = mode;
        this.setCustomCursor();
    }

    protected getSvgString(): string {
        if (this._mode === TranslationCursorMode.GRAB) {
            return `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M12 2v20M2 12h20M5 9l-3 3 3 3M19 9l3 3-3 3M9 5l3-3 3 3M9 19l3 3 3-3"/></svg>
            `;
        }
        return `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M12 2v20M2 12h20M5 9l-3 3 3 3M19 9l3 3-3 3M9 5l3-3 3 3M9 19l3 3 3-3"/></svg>
            `;
    }

    protected getFallbackCursor(): string {
        return 'move';
    }
}
